
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'data-privacy-request-ui',
  currentProjectVersion: 'static-1.5803',
  depVersions: {
  "data-privacy-request-ui": "static-1.5803",
  "client-types": "static-1.496",
  "data-fetching-client": "static-1.9941",
  "head-dlb": "static-1.5007",
  "hs-test-utils": "static-1.8317",
  "hub-http-shared-msw-handlers": "static-1.10590",
  "hubspot-dlb": "static-2.1882",
  "HubStyleTokens": "static-2.11773",
  "I18n": "static-7.1669",
  "jasmine-runner": "static-1.6736",
  "quartz": "static-1.7436",
  "react-dlb": "static-1.88",
  "rpc-client-utils": "static-1.4950",
  "ui-components-test-utils": "static-1.5910",
  "UIComponents": "static-3.8719",
  "webpack-env": "static-1.54",
  "apollo-stack-hubspot": "static-3.92",
  "foundations-assets": "static-1.5168",
  "foundations-components": "static-1-ech-accordiontransition-jank.31",
  "foundations-components-test-utils": "static-1-ech-accordiontransition-jank.31",
  "foundations-theming": "static-1.4756",
  "hub-http": "static-1.6499",
  "quartz-config": "static-1.1214",
  "quartz-core": "static-1.6655",
  "quartz-routing": "static-1.866",
  "quick-fetch": "static-1.4121",
  "raven": "static-3.5925",
  "react": "static-7.192",
  "react-rhumb": "static-1.17004",
  "SharedI18nStrings": "static-1.183",
  "ui-addon-i18n": "static-1.11431",
  "usage-tracker": "static-1.7637",
  "usage-tracker-anonymous": "static-1.6054",
  "usage-tracker-core": "static-1.7487",
  "enviro": "static-4.455",
  "hs-promise-rejection-tracking": "static-1.5587",
  "PortalIdParser": "static-2.404",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "hubspot-url-utils": "static-1.4297",
  "immutable": "static-2.83",
  "metrics-js": "static-1.9867",
  "react-redux": "static-7.75",
  "redux": "static-4.76",
  "styled-components": "static-2.95",
  "bend-plugin-trellis-migration": "static-1.3609",
  "moment": "static-3.75",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3713",
  "quartz-webpack": "static-1.3660",
  "bend-plugin-quartz-routing": "static-1.514",
  "fast-json-stable-stringify": "static-1.4",
  "graphql": "static-1.87",
  "HeadJS": "static-2.794",
  "framer-motion": "static-1.77",
  "hs-test-utils-bend-plugin": "static-1.3428",
  "msw": "static-1.39",
  "testing-library": "static-1.157",
  "ts-schema": "static-1.4283",
  "i18n-data": "static-1.229",
  "moment-timezone": "static-5.89",
  "react-utils": "static-2.5545",
  "StyleGuideUI": "static-3.501",
  "jasmine": "static-4.4598",
  "bend-plugin-chirp-manifest": "static-1.360",
  "chirp-fetch": "static-1.2178",
  "HubStyle": "static-2.12080",
  "ui-addon-draggable": "static-3.5043",
  "cssUtils": "static-1.905",
  "hs-story-utils": "static-1.9710",
  "icons": "static-2.680",
  "react-create-root-preference": "static-1.68",
  "react-select-plus": "static-1.111",
  "react-virtualized": "static-2.105",
  "ui-images": "static-2.1243",
  "bend-plugin-foundations-components": "static-1-ech-accordiontransition-jank.31",
  "floating-ui": "static-1.62",
  "foundations-theming-specialty": "static-1.2472",
  "react-aria": "static-1.71",
  "tanstack-table": "static-1.59",
  "trellis-assets": "static-1.2598",
  "ui-fonts": "static-1.1035",
  "foundations-components-legacy": "static-1-ech-accordiontransition-jank.31",
  "bend-plugin-foundations-theming": "static-1.3239",
  "foundations-theming-base": "static-1.3741",
  "stylex": "static-1.39",
  "hs-locale-management": "static-1.282",
  "opentelemetry-fe-types": "static-1.53",
  "dispatcher": "static-1.143",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.876",
  "hubspotter-http": "static-1.4853",
  "mobile-manifest-mixins": "static-1.575",
  "module-federation": "static-1.31",
  "opentelemetry-fe": "static-1.428",
  "quartz-auth": "static-1.1111",
  "quartz-head": "static-1.1101",
  "quartz-i18n": "static-1.1111",
  "quartz-test": "static-1.1111",
  "quartz-tracking": "static-1.815",
  "trellis-components": "static-1.2617",
  "usage-tracker-container": "static-1.7627",
  "csstype": "static-1.50",
  "web-vitals": "static-1.13",
  "react-input-autosize": "static-2.17",
  "bender-build-tools": "static-1.3431",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "react-flip-move": "static-1.76",
  "sassPrefix": "static-1.176",
  "stylex-utils": "static-1.138",
  "trellis-theming": "static-1.1260",
  "opentelemetry-web": "static-1.11",
  "hubspotter-http-shared-msw-handlers": "static-1.10588",
  "usage-tracker-session-replay": "static-1.5323",
  "base-ui": "static-1.20",
  "react-day-picker": "static-1.8",
  "tanstack-virtual": "static-1.36",
  "amplitude-session-replay-browser": "static-1.60"
},
  depPathPrefixes: {
  "data-privacy-request-ui": "/data-privacy-request-ui/static-1.5803",
  "client-types": "/client-types/static-1.496",
  "data-fetching-client": "/data-fetching-client/static-1.9941",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-test-utils": "/hs-test-utils/static-1.8317",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10590",
  "hubspot-dlb": "/hubspot-dlb/static-2.1882",
  "HubStyleTokens": "/HubStyleTokens/static-2.11773",
  "I18n": "/I18n/static-7.1669",
  "jasmine-runner": "/jasmine-runner/static-1.6736",
  "quartz": "/quartz/static-1.7436",
  "react-dlb": "/react-dlb/static-1.88",
  "rpc-client-utils": "/rpc-client-utils/static-1.4950",
  "ui-components-test-utils": "/ui-components-test-utils/static-1.5910",
  "UIComponents": "/UIComponents/static-3.8719",
  "webpack-env": "/webpack-env/static-1.54",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.92",
  "foundations-assets": "/foundations-assets/static-1.5168",
  "foundations-components": "/foundations-components/static-1-ech-accordiontransition-jank.31",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1-ech-accordiontransition-jank.31",
  "foundations-theming": "/foundations-theming/static-1.4756",
  "hub-http": "/hub-http/static-1.6499",
  "quartz-config": "/quartz-config/static-1.1214",
  "quartz-core": "/quartz-core/static-1.6655",
  "quartz-routing": "/quartz-routing/static-1.866",
  "quick-fetch": "/quick-fetch/static-1.4121",
  "raven": "/raven/static-3.5925",
  "react": "/react/static-7.192",
  "react-rhumb": "/react-rhumb/static-1.17004",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.183",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11431",
  "usage-tracker": "/usage-tracker/static-1.7637",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.6054",
  "usage-tracker-core": "/usage-tracker-core/static-1.7487",
  "enviro": "/enviro/static-4.455",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4297",
  "immutable": "/immutable/static-2.83",
  "metrics-js": "/metrics-js/static-1.9867",
  "react-redux": "/react-redux/static-7.75",
  "redux": "/redux/static-4.76",
  "styled-components": "/styled-components/static-2.95",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3609",
  "moment": "/moment/static-3.75",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3713",
  "quartz-webpack": "/quartz-webpack/static-1.3660",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.514",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "graphql": "/graphql/static-1.87",
  "HeadJS": "/HeadJS/static-2.794",
  "framer-motion": "/framer-motion/static-1.77",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3428",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.157",
  "ts-schema": "/ts-schema/static-1.4283",
  "i18n-data": "/i18n-data/static-1.229",
  "moment-timezone": "/moment-timezone/static-5.89",
  "react-utils": "/react-utils/static-2.5545",
  "StyleGuideUI": "/StyleGuideUI/static-3.501",
  "jasmine": "/jasmine/static-4.4598",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.360",
  "chirp-fetch": "/chirp-fetch/static-1.2178",
  "HubStyle": "/HubStyle/static-2.12080",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.5043",
  "cssUtils": "/cssUtils/static-1.905",
  "hs-story-utils": "/hs-story-utils/static-1.9710",
  "icons": "/icons/static-2.680",
  "react-create-root-preference": "/react-create-root-preference/static-1.68",
  "react-select-plus": "/react-select-plus/static-1.111",
  "react-virtualized": "/react-virtualized/static-2.105",
  "ui-images": "/ui-images/static-2.1243",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1-ech-accordiontransition-jank.31",
  "floating-ui": "/floating-ui/static-1.62",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2472",
  "react-aria": "/react-aria/static-1.71",
  "tanstack-table": "/tanstack-table/static-1.59",
  "trellis-assets": "/trellis-assets/static-1.2598",
  "ui-fonts": "/ui-fonts/static-1.1035",
  "foundations-components-legacy": "/foundations-components-legacy/static-1-ech-accordiontransition-jank.31",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3239",
  "foundations-theming-base": "/foundations-theming-base/static-1.3741",
  "stylex": "/stylex/static-1.39",
  "hs-locale-management": "/hs-locale-management/static-1.282",
  "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1.53",
  "dispatcher": "/dispatcher/static-1.143",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.876",
  "hubspotter-http": "/hubspotter-http/static-1.4853",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.575",
  "module-federation": "/module-federation/static-1.31",
  "opentelemetry-fe": "/opentelemetry-fe/static-1.428",
  "quartz-auth": "/quartz-auth/static-1.1111",
  "quartz-head": "/quartz-head/static-1.1101",
  "quartz-i18n": "/quartz-i18n/static-1.1111",
  "quartz-test": "/quartz-test/static-1.1111",
  "quartz-tracking": "/quartz-tracking/static-1.815",
  "trellis-components": "/trellis-components/static-1.2617",
  "usage-tracker-container": "/usage-tracker-container/static-1.7627",
  "csstype": "/csstype/static-1.50",
  "web-vitals": "/web-vitals/static-1.13",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "bender-build-tools": "/bender-build-tools/static-1.3431",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "react-flip-move": "/react-flip-move/static-1.76",
  "sassPrefix": "/sassPrefix/static-1.176",
  "stylex-utils": "/stylex-utils/static-1.138",
  "trellis-theming": "/trellis-theming/static-1.1260",
  "opentelemetry-web": "/opentelemetry-web/static-1.11",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10588",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5323",
  "base-ui": "/base-ui/static-1.20",
  "react-day-picker": "/react-day-picker/static-1.8",
  "tanstack-virtual": "/tanstack-virtual/static-1.36",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60"
}
};
